import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=6b41b252&scoped=true&"
import script from "./Blog.js?vue&type=script&lang=js&"
export * from "./Blog.js?vue&type=script&lang=js&"
import style0 from "./Blog.scss?vue&type=style&index=0&id=6b41b252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b41b252",
  null
  
)

export default component.exports